import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/match_plan_retirement_plan_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
// inverse:null because the registered match-plan.schema.ts does not declare a
// reciprocal matchPlanRetirementPlans hasMany (the API match_plan_resource.rb
// does; set it only if that hasMany is added to the FE match-plan schema too).
const MatchPlanRetirementPlanSchema = withDefaults({
  type: 'match-plan-retirement-plan',
  fields: [
    { kind: 'attribute', name: 'retirementPlan' },
    {
      kind: 'belongsTo',
      name: 'matchPlan',
      type: 'match-plan',
      options: { async: false, inverse: null },
    },
  ],
});

export default MatchPlanRetirementPlanSchema;
